import React from "react";
import {sessionStore} from "../../store/sessionStore";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import {LoginServices} from "../../services/LoginServices";

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const user = sessionStore.userId;

  return (
    <div className="flex w-full h-16 shadow-md items-center px-4">
      <div className="font-bold w-fit text-sm lg:text-xl text-start sm:text-center">
        <h1>ESTUDO</h1>
        <h1 className="text-green-700">EPIDEMIOLÓGICO</h1>
      </div>

      <div className="ml-auto flex flex-row items-center space-x-3 text-wrap">
        <div className="flex flex-col items-end">
          <span className="font-semibold text-gray-700 text-sm lg:text-base">Beneficiario</span>
          <span className="font-semibold text-green-700 text-sm lg:text-base text-end">{user}</span>
        </div>

        {isDropdownOpen ? <IoIosArrowUp className="text-green-700 cursor-pointer" onClick={() => setIsDropdownOpen(!isDropdownOpen)} /> : <IoIosArrowDown className="text-green-700 cursor-pointer" onClick={() => setIsDropdownOpen(!isDropdownOpen)} />}

        {isDropdownOpen && (
          <div className="absolute top-[4.1rem] right-4 w-40 h-20 bg-white shadow-lg flex flex-col items-center z-50">
            <a href="/profile" className="w-full h-1/2 flex items-center justify-center hover:bg-gray-100">Perfil</a>
            <p onClick={LoginServices.logout} className="w-full h-1/2 flex items-center justify-center hover:bg-gray-100 cursor-pointer">Sair</p>
          </div>
        )}
      </div>
    </div>
  );

}

export default Header;